import { render, staticRenderFns } from "./WebServiceCredentialDetailsTB.vue?vue&type=template&id=edc13712&"
import script from "./WebServiceCredentialDetailsTB.vue?vue&type=script&lang=js&"
export * from "./WebServiceCredentialDetailsTB.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentVOP/build/VOPWebApp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('edc13712')) {
      api.createRecord('edc13712', component.options)
    } else {
      api.reload('edc13712', component.options)
    }
    module.hot.accept("./WebServiceCredentialDetailsTB.vue?vue&type=template&id=edc13712&", function () {
      api.rerender('edc13712', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/routing/WebService/WebServiceCredentialDetailsTB.vue"
export default component.exports